import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperHeader } from 'vuetify/lib/components/VStepper';
import { VStepperItems } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("my_tasks.bulk_load"))),
      ]),
      _c(
        "actions-component",
        [
          _c(
            "template",
            { slot: "description" },
            [
              _c(VBreadcrumbs, {
                staticClass: "pa-0",
                attrs: { items: _vm.getBreadcrumbs },
              }),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "7" } },
            [
              _vm.bulkStep > 1
                ? _c(
                    VCard,
                    { staticClass: "mt-2 pa-2 card-filters text-left" },
                    [
                      _c(
                        VRow,
                        [
                          _c(
                            VCol,
                            { attrs: { cols: "2" } },
                            [
                              _c("b-icon", {
                                directives: [
                                  {
                                    name: "b-tooltip",
                                    rawName: "v-b-tooltip.hover",
                                    modifiers: { hover: true },
                                  },
                                ],
                                staticClass: "h4",
                                style: {
                                  cursor: _vm.isHovering
                                    ? "pointer"
                                    : "default",
                                },
                                attrs: {
                                  icon: "arrow-left-square-fill",
                                  variant:
                                    _vm.isHovering && _vm.bulkStep > 1
                                      ? "primary"
                                      : "secondary",
                                },
                                on: {
                                  mouseover: function ($event) {
                                    _vm.isHovering = true
                                  },
                                  mouseout: function ($event) {
                                    _vm.isHovering = false
                                  },
                                  click: function ($event) {
                                    return _vm.onBack()
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(VCol, [
                            _c("div", { staticClass: "text-h6" }, [
                              _vm._v(_vm._s(_vm.$t("my_tasks.last_step"))),
                            ]),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        VRow,
        { attrs: { justify: "center" } },
        [
          _c(
            VCol,
            { attrs: { cols: "7" } },
            [
              _c(
                VCard,
                { staticClass: "mt-2" },
                [
                  _c(
                    VStepper,
                    {
                      model: {
                        value: _vm.bulkStep,
                        callback: function ($$v) {
                          _vm.bulkStep = $$v
                        },
                        expression: "bulkStep",
                      },
                    },
                    [
                      _c(
                        VStepperHeader,
                        [
                          _c(
                            VStepperStep,
                            {
                              attrs: { complete: _vm.bulkStep > 1, step: "1" },
                            },
                            [_vm._v(_vm._s(_vm.$t("my_tasks.step1")))]
                          ),
                          _c(VDivider),
                          _c(
                            VStepperStep,
                            {
                              attrs: { complete: _vm.bulkStep > 2, step: "2" },
                            },
                            [_vm._v(_vm._s(_vm.$t("my_tasks.step2")))]
                          ),
                          _c(VDivider),
                          _c(VStepperStep, { attrs: { step: "3" } }, [
                            _vm._v(_vm._s(_vm.$t("my_tasks.step3"))),
                          ]),
                        ],
                        1
                      ),
                      _c(
                        VStepperItems,
                        [
                          _c(
                            VStepperContent,
                            { attrs: { step: "1" } },
                            [
                              _c(
                                VCard,
                                [
                                  _c(
                                    VContainer,
                                    { staticClass: "pb-0" },
                                    [
                                      _vm.bulkStep >= 1
                                        ? _c(
                                            VRow,
                                            [
                                              _c(VSelect, {
                                                attrs: {
                                                  items: _vm.bulkOptions,
                                                  id: "bulkType",
                                                  disabled: _vm.bulkStep !== 1,
                                                  outlined: "",
                                                  dense: "",
                                                },
                                                model: {
                                                  value: _vm.bulkType,
                                                  callback: function ($$v) {
                                                    _vm.bulkType = $$v
                                                  },
                                                  expression: "bulkType",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        VRow,
                                        { attrs: { justify: "center" } },
                                        [
                                          _vm.bulkType !== null &&
                                          _vm.bulkStep >= 1
                                            ? _c(
                                                VBtn,
                                                {
                                                  attrs: {
                                                    color: "secondary",
                                                    outlined: "",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.downloadTemplate()
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VIcon,
                                                    { attrs: { small: "" } },
                                                    [_vm._v("icon-download")]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "my_tasks.download_template"
                                                      )
                                                    )
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _vm.bulkType !== null
                                            ? _c(
                                                VBtn,
                                                {
                                                  staticClass: "ml-3",
                                                  attrs: { color: "primary" },
                                                  on: {
                                                    click: function ($event) {
                                                      _vm.bulkStep += 1
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VIcon,
                                                    { attrs: { small: "" } },
                                                    [_vm._v("icon-check")]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t("btns.confirm")
                                                    )
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            VStepperContent,
                            { attrs: { step: "2" } },
                            [
                              _c(
                                VCard,
                                { staticClass: "pa-2" },
                                [
                                  _c(
                                    VContainer,
                                    [
                                      _vm.bulkStep >= 1
                                        ? _c(
                                            VRow,
                                            [
                                              _c(VSelect, {
                                                attrs: {
                                                  items: _vm.bulkOptions,
                                                  id: "bulkType",
                                                  disabled: _vm.bulkStep !== 1,
                                                  outlined: _vm.bulkStep == 1,
                                                  filled: _vm.bulkStep !== 1,
                                                  dense: "",
                                                },
                                                model: {
                                                  value: _vm.bulkType,
                                                  callback: function ($$v) {
                                                    _vm.bulkType = $$v
                                                  },
                                                  expression: "bulkType",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _c(
                                        VRow,
                                        [
                                          _vm.bulkType == "table" &&
                                          _vm.isSynapseActive
                                            ? _c(VSelect, {
                                                attrs: {
                                                  items: _vm.list_source,
                                                  outlined: "",
                                                  dense: "",
                                                },
                                                model: {
                                                  value: _vm.source,
                                                  callback: function ($$v) {
                                                    _vm.source = $$v
                                                  },
                                                  expression: "source",
                                                },
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm.bulkType !== null && _vm.bulkStep >= 2
                                        ? _c(
                                            VRow,
                                            { staticClass: "mt-2" },
                                            [
                                              _c(VFileInput, {
                                                attrs: {
                                                  "show-size": "",
                                                  counter: "",
                                                  outlined: "",
                                                  small: "",
                                                  dense: "",
                                                  label: _vm.load_csv,
                                                  accept: ".csv",
                                                  disabled:
                                                    _vm.isLoading ||
                                                    _vm.bulkStep === 3,
                                                },
                                                model: {
                                                  value: _vm.csvFile,
                                                  callback: function ($$v) {
                                                    _vm.csvFile = $$v
                                                  },
                                                  expression: "csvFile",
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.csvFile
                                        ? _c(
                                            VRow,
                                            {
                                              staticClass: "mt-2",
                                              attrs: { justify: "center" },
                                            },
                                            [
                                              _c(
                                                VBtn,
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    disabled:
                                                      _vm.isLoading ||
                                                      _vm.bulkStep === 3,
                                                  },
                                                  on: { click: _vm.onSubmit },
                                                },
                                                [
                                                  _c(
                                                    VIcon,
                                                    { attrs: { small: "" } },
                                                    [_vm._v("icon-upload")]
                                                  ),
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "my_tasks.upload_file"
                                                      )
                                                    )
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm.bulkStep >= 2 && _vm.error_message
                                        ? _c(
                                            VRow,
                                            {
                                              staticClass: "mt-2",
                                              attrs: { align: "center" },
                                            },
                                            [
                                              _c(
                                                VCol,
                                                [
                                                  _c(
                                                    VAlert,
                                                    {
                                                      attrs: {
                                                        type: _vm.TYPE_ERROR,
                                                        outlined: "",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-h6",
                                                        },
                                                        [_vm._v("Error")]
                                                      ),
                                                      _c("div", [
                                                        _vm._v(
                                                          _vm._s(_vm.message)
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        VStepperContent,
                        { attrs: { step: "3" } },
                        [
                          _c(
                            VCard,
                            { staticClass: "pa-2" },
                            [
                              _c(
                                VContainer,
                                [
                                  _c(
                                    VRow,
                                    [
                                      _c(
                                        VCol,
                                        [
                                          _vm.showMessageServer
                                            ? _c(
                                                VAlert,
                                                {
                                                  attrs: {
                                                    outlined: "",
                                                    type: _vm.colorAlert,
                                                    text: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    VRow,
                                                    {
                                                      attrs: {
                                                        align: "center",
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        VCol,
                                                        { staticClass: "grow" },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.messageServer
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        VCol,
                                                        {
                                                          staticClass: "shrink",
                                                        },
                                                        [
                                                          (_vm.tableauRecords &&
                                                            _vm.tableauRecords
                                                              .length) ||
                                                          (_vm.tplToInform &&
                                                            _vm.tplToInform
                                                              .length)
                                                            ? _c(
                                                                VBtn,
                                                                {
                                                                  attrs: {
                                                                    color:
                                                                      "secondary",
                                                                    block: "",
                                                                    outlined:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.openDetails()
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "i",
                                                                    {
                                                                      staticClass:
                                                                        "material-icons md-16",
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "description"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _c("span", [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "my_tasks.details"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm.bulkStep >= 2 && _vm.error_message
                                    ? _c(
                                        VRow,
                                        { staticClass: "mt-2" },
                                        [
                                          _c(
                                            VCol,
                                            [
                                              _c(
                                                VAlert,
                                                {
                                                  attrs: {
                                                    type: _vm.TYPE_ERROR,
                                                    outlined: "",
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "text-h6" },
                                                    [_vm._v("Error")]
                                                  ),
                                                  _c("div", [
                                                    _vm._v(_vm._s(_vm.message)),
                                                  ]),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("DialogsComponent", {
        ref: "dialog",
        attrs: { title: _vm.$t("my_tasks.bulk_load"), width: 700 },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _c("inform-massive-upload", {
                  attrs: {
                    tplToWork: _vm.tplToInform,
                    tableauRecords: _vm.tableauRecords,
                  },
                  on: {
                    cancel: function ($event) {
                      return _vm.$refs.dialog.onClose()
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }